import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updatePopup } from "services";

import { GET_ALL_ADMIN_POPUPS, GET_ALL_ADMIN_POPUPS_BY_ID, UPDATE_ADMIN_POPUPS } from "consts";

export const useUpdateAdminPopup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_ADMIN_POPUPS],
    mutationFn: updatePopup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_POPUPS] });
      queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_POPUPS_BY_ID] });
    },
  });
};
